export default __webpack_public_path__ + "static/media/gif.b4283b6f.svg";